<template>
  <div class="body-wrapper">
    <Header :title="'Users'" />
    <div class="user-filters">
      <div class="search-field">
        <input 
          type="text" 
          placeholder="Search..." 
          v-model="searchFilter"/>
      </div>
      <div class="spacer"></div>
      <select v-model="userTypeFilter">
        <option value="">All users</option>
        <option value="pro-all">All pro users</option>
        <option value="pro-paying">All paying pro users</option>
        <option value="pro-free">All free pro users</option>
        <option value="verified-all">All verified users</option>
      </select>
    </div>

    <DataTable 
      url="v1/manage_users"
      :fields="fields"
      :extraParams="extraParams"
      :options="actionOptions"
      @details-clicked="detailsClicked" />

    <UserDetailModal
      v-if="viewUserDetails"/>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import DataTable from '../components/table/DataTable.vue';
import { formatDateTime } from '@/utils'
import UserDetailModal from '../components/modals/UserDetailModal.vue';

export default {
  name: 'Users',

  components: {
    Header,
    DataTable,
    UserDetailModal,
  },

  data() {
    return {
      searchFilter: '',
      userTypeFilter: '',
      actionOptions: [
        {
          name: 'Reset password',
          action: 'resetUserPassword',
        },
        {
          name: 'Edit User',
          action: 'editUserDetails',
        },
        {
          name: 'Verify User',
          action: 'verifyUser',
        },
        {
          name: 'Give Pro',
          action: 'giveProUser',
        },
        {
          type: 'divider'
        },
        {
          name: 'Ban user',
          action: 'banUser',
        },
      ],
    }
  },

  methods: {
    detailsClicked(event) {
      this.$store.dispatch('users/userClicked', event);
    }
  },
  
  computed: {
    fields() {
      return [
        {
          name: 'name-slot',
          title: 'User',
          sortField: 'first_name',
          width: '15%'
        },
        {
          name: "gender-slot",
          title: 'G',
        },
        {
          name: "verified-slot",
          title: 'V',
        },
        {
          name: "pro-member-slot",
          title: 'P',
        },
        {
          name: "banned-member-slot",
          title: 'B',
        },
        {
          name: 'email',
          title: 'Email',
          sortField: 'email',
          width: '20%'
        },
        {
          name: 'created_at',
          title: 'Joined',
          sortField: 'created_at',
          formatter: formatDateTime
        },
        {
          name: "last_active_at",
          title: 'Last Active',
          sortField: 'last_active_at',
          formatter: formatDateTime
        },
        {
          name: "location",
          title: 'Location',
          sortField: 'location',
          width: '10%'
        },
        {
          name: "reported",
          title: 'Reported',
          sortField: 'reported'
        },
        {
          name: 'user-actions-slot',
          title: '',
        },
      ]
    },

    extraParams() {
      return {
        'search': this.searchFilter,
        'user_type': this.userTypeFilter,
      };
    },

    viewUserDetails: {
      get () {
        return this.$store.state.users.viewUserDetails
      },
      set (value) {
        this.$store.commit('users/updateAttribute', {value: value, type: 'viewUserDetails'})
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.user-filters {
  display: flex;
  justify-content: flex-start;
  padding: $spacing-base;
  padding-top: $spacing-base;
  gap: $spacing-small;

  input {
    height: 28px;
    width: 300px;
  }

  .spacer {
    flex: 1;
  }

  select {
    height: 28px;
    width: 150px;
    background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
    background-position: calc(100% - 10px) calc(0.7em + 4px),
    calc(100% - 5px) calc(0.7em + 4px),
    calc(100% - 2.5em) 0.5em;
    background-size: 5px 5px, 5px 6px, 0px 3em;
  }
}
</style>
